export default "__VITE_ASSET__DO0OL7Se__"